import { Fragment } from "react";
import { formatFeeAdjustmentDescriptionParts } from "../service/feeAdjustmentDescription";
import type { FeeAdjustmentLineDisplay } from "../types";
import "./feeAdjustmentServiceTable.css";

/** 数量、规格和单价按各自增减方向着色。 */
export function FeeAdjustmentDescription({ line, compactAmounts = false, groupAmounts = false, formatAmount }: { line: FeeAdjustmentLineDisplay; compactAmounts?: boolean; groupAmounts?: boolean; formatAmount?: (value: string | null | undefined, signed?: boolean) => string }) {
  return <span className="fee-adjustment-description">{formatFeeAdjustmentDescriptionParts(line, compactAmounts, groupAmounts, formatAmount).map((part, index) => <Fragment key={index}>{index > 0 ? "，" : null}<span data-direction={part.direction}>{part.text}</span></Fragment>)}</span>;
}
